import apiClient from '../client';

export interface MonthlySalesRow {
  Year: number;
  Month: number;
  Revenue: number;
  OrderCount: number;
}

export interface DailySalesRow {
  Year: number;
  Month: number;
  Day: number;
  Revenue: number;
  OrderCount: number;
}

export interface CustomerSalesRow {
  CustomerName: string;
  CustomerId: string;
  Year1Revenue: number;
  Year1Orders: number;
  Year2Revenue: number;
  Year2Orders: number;
}

export interface FabricSalesRow {
  Material: string;
  Year1Revenue: number;
  Year1Orders: number;
  Year2Revenue: number;
  Year2Orders: number;
}

export interface CitySalesRow {
  City: string;
  Revenue: number;
  OrderCount: number;
}

export interface StateSalesRow {
  State: string;
  Year1Revenue: number;
  Year1Orders: number;
  Year2Revenue: number;
  Year2Orders: number;
}

export interface RevenueSummaryRow {
  Year: number;
  TotalRevenue: number;
  TotalOrders: number;
  AvgOrderValue: number;
}

export const dashcoverSalesService = {
  getRevenueSummary: async (year1: number, year2: number): Promise<RevenueSummaryRow[]> => {
    const res = await apiClient.get('/dashcover-sales/summary', {
      params: { year1, year2 },
    });
    return res.data;
  },

  getDailySales: async (year1: number, year2: number, fromMonth: number, toMonth: number, fromDay?: number, toDay?: number): Promise<DailySalesRow[]> => {
    const res = await apiClient.get('/dashcover-sales/daily-sales', {
      params: { year1, year2, fromMonth, toMonth, fromDay, toDay },
    });
    return res.data;
  },

  getMonthlySales: async (year1: number, year2: number): Promise<MonthlySalesRow[]> => {
    const res = await apiClient.get('/dashcover-sales/monthly-sales', {
      params: { year1, year2 },
    });
    return res.data;
  },

  getSalesByCity: async (state: string, year: number, month: number): Promise<CitySalesRow[]> => {
    const res = await apiClient.get('/dashcover-sales/sales-by-city', {
      params: { state, year: year || 0, month },
    });
    return res.data;
  },

  getSalesByState: async (year1: number, year2: number, month: number): Promise<StateSalesRow[]> => {
    const res = await apiClient.get('/dashcover-sales/sales-by-state', {
      params: { year1, year2, month },
    });
    return res.data;
  },

  getSalesByCustomer: async (year1: number, year2: number, month: number, limit = 25): Promise<CustomerSalesRow[]> => {
    const res = await apiClient.get('/dashcover-sales/sales-by-customer', {
      params: { year1, year2, month, limit },
    });
    return res.data;
  },

  getSalesByFabric: async (
    year1: number,
    year2: number,
    month: number,
    limit = 25,
    fromMonth?: number,
    toMonth?: number,
    fromDay?: number,
    toDay?: number,
  ): Promise<FabricSalesRow[]> => {
    const res = await apiClient.get('/dashcover-sales/sales-by-fabric', {
      params: { year1, year2, month, limit, fromMonth, toMonth, fromDay, toDay },
    });
    return res.data;
  },
};
